var map = {
	"./de.json": [
		"./src/config/language/de.json",
		"src_config_language_de_json"
	],
	"./en.json": [
		"./src/config/language/en.json",
		"src_config_language_en_json"
	],
	"./es.json": [
		"./src/config/language/es.json",
		"src_config_language_es_json"
	],
	"./fr.json": [
		"./src/config/language/fr.json",
		"src_config_language_fr_json"
	],
	"./it.json": [
		"./src/config/language/it.json",
		"src_config_language_it_json"
	],
	"./ja.json": [
		"./src/config/language/ja.json",
		"src_config_language_ja_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/config/language lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;